import { PipeTransform } from '@angular/core';
var PaymentNumberPipe = /** @class */ (function () {
    function PaymentNumberPipe() {
    }
    PaymentNumberPipe.prototype.transform = function (number) {
        return number && number.replace(/#/g, '•');
    };
    return PaymentNumberPipe;
}());
export { PaymentNumberPipe };
